module.exports = __webpack_public_path__ + "img/bg-middle.93b4521f.png";